export async function initYoutubeVideo() {
  const elements = document.querySelectorAll(".yt-img");
  if (elements.length) {
    for (const img of elements) {
      const parent = img.parentElement;
      const id = img.id;
      const container = img.parentElement;
      const videoContainer = container.querySelector(`#video-container-${id}`);
      const overlayBg = document.createElement("div");
      overlayBg.classList.add("yt-img-overlay-bg", "d-flex");

      const overlay = document.createElement("div");
      overlay.classList.add("yt-img-overlay");

      const setWidthAndHeight = () => {
        img.style.width = "860px";
        container.style.width = "860px;";
      };
      img.addEventListener("load", () => {
        setWidthAndHeight();
      });

      setWidthAndHeight();
      container.appendChild(overlayBg);
      overlayBg.appendChild(overlay);
      let overlayText = null;

      if (
        videoContainer &&
        videoContainer.dataset &&
        (videoContainer.dataset.tag || videoContainer.dataset.title)
      ) {
        overlayText = document.createElement("div");
        const overlayTextTag = document.createElement("div");
        const overlayTextTitle = document.createElement("div");

        overlayText.classList.add("yt-img-overlay-text");
        overlayTextTag.classList.add("yt-img-overlay__tag");
        overlayTextTitle.classList.add("yt-img-overlay__title");

        overlayTextTag.innerHTML = videoContainer.dataset.tag ?? "";
        overlayTextTitle.innerHTML = videoContainer.dataset.title ?? "";

        overlayText.appendChild(overlayTextTag);
        overlayText.appendChild(overlayTextTitle);
        overlayBg.appendChild(overlayText);
      }
      if (videoContainer && img) {
        const clickHandler = () => {
          const iframe = document.createElement("iframe");
          iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1`;
          iframe.allowfullscreen = true;
          iframe.frameborder = 0;
          iframe.width = "100%";
          iframe.height = container.style.height ?? "auto";
          iframe.allow = "autoplay";
          iframe.style.aspectRatio = "16/9";
          iframe.style.position = "relative";
          iframe.style.zIndex = "100";
          videoContainer.appendChild(iframe);
          img.style.display = "none";
          overlay.style.display = "none";
          overlayBg.style.display = "none";
          parent.classList.add("video");
          if (overlayText) {
            overlayText.style.display = "none";
          }
          overlayBg.removeEventListener("click", clickHandler);
          overlayBg.remove();
        };
        overlayBg.addEventListener("click", clickHandler);
      }
    }
  }
}
